// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuoteBanner_wrapper__5fT3k","quoteUp":"QuoteBanner_quoteUp__KVLX4","quoteDown":"QuoteBanner_quoteDown__C5vwf","item":"QuoteBanner_item__8gwnz"};